export class OAuthMissingResponseDataError extends Error {
  constructor() {
    super();
    this.name = 'OAuthMissingResponseDataError';
    this.message = `Authorization 'code', 'state' or 'scope' is missing from the OAuth response.`;
  }
}
